import React from 'react';
import { Tray } from '../../components/elements';
import { isSurveyTemplateManifestationData } from '../../components/Surveys/isSurveyTemplateManifestationData';
import { isSurveyTemplateUnitData } from '../../components/Surveys/isSurveyTemplateUnitData';
import { ISurveyTemplateElementGroupData } from '../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../components/Surveys/ISurveyTemplateUnitData';
import { SurveyEditCrowBeeldkwaliteitUnitResult } from './CrowBeeldkwaliteitUnitResult';
import { SurveyEditCrowBeeldkwaliteitManifestationResult } from './SurveyEditCrowBeeldkwaliteitManifestationResult';

export function SurveyEditCrowBeeldkwaliteitResult(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    if (isSurveyTemplateUnitData(props)) {
        return <SurveyEditCrowBeeldkwaliteitUnitResult {...props} />;
    } else if (isSurveyTemplateManifestationData(props)) {
        return <SurveyEditCrowBeeldkwaliteitManifestationResult {...props} />;
    }
    return <Tray>&nbsp;</Tray>;
}
